import { useQuery } from '@tanstack/react-query';
import { gridColumnInfo } from 'services/grid';

export const useGetColumnsGrid = (gridName, options) => {
  return useQuery({
    queryKey: ['pim', 'grid-column-info', gridName],
    queryFn: async ({ queryKey }) => {
      const gridName = queryKey[2];
      const response = await gridColumnInfo(gridName);

      return response?.columns;
    },
    enabled: !!gridName,
    placeholderData: [],
    ...options,
  });
};
